import HomeIcon from "assets/homev2.svg"
import ProfileIcon from "assets/user-circle.svg"
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearPersistedData, resetData, resetSettings, setProviders, setVisittype } from "./../redux/store";
import useModalStore from "zustand/zustandstore";
import RaiseTicketAuth from "pages/auth/screens/raiseticketauth";
import ToastMessage from "utils/muialerts/righttoptoast";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import helpicon from 'assets/svgs/help.svg'
const V2header=({setui})=>{
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isOpen, openModal, closeModal,setModalValue } = useModalStore();
    const navigate=useNavigate()
    const menuRef = useRef(null);
    const mydata=useModalStore()
    const dispatch=useDispatch()
   const [ishelpmodal,setIsHelpModal]=useState(false)
     const [alertmessage, setAlertMessage] = useState('');
         const [open, setOpen] = useState(false);
         const [severity, setSeverity] = useState('success');
      const handleProfileClick = () => {
          
            setIsMenuOpen(!isMenuOpen);
            navigate('/manage-profile');
        };
    
      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      }
        // Close the menu if clicking outside of it
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (menuRef.current && !menuRef.current.contains(event.target)) {
                    setIsMenuOpen(false); // Close menu
                }
            };
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [menuRef]);
        const toggleMenu = () => {
          setIsMenuOpen(!isMenuOpen);
      };

    return(<>
    <div
  className={`flex justify-end p-4 space-x-4 ${
    mydata.recording ? 'pointer-events-none ' : ''
  }`}
>

 <div className="cursor-pointer" onClick={()=>toggleMenu()}>

    <img src={ProfileIcon}      
            className="h-5 sm:h-6 cursor-pointer" />
</div>   
      <div className="cursor-pointer" onClick={()=>{
           setModalValue({ screen :0}) 
           setModalValue({selectedRecord:{}})
        navigate('/v2')}}
        >
                    <img src={HomeIcon} className="h-5 sm:h-6 cursor-pointer" />
      </div><img src={helpicon} className=" h-5 sm:h-6 cursor-pointer"
 onClick={()=>setIsHelpModal(true)}
/>

                              {isMenuOpen && (
            <div
              ref={menuRef}
              className="absolute right-2 mt-6 bg-white border border-gray-200 rounded-lg shadow-lg z-10 w-36 max-w-auto"
            >
              <ul className="py-2">
                <li
                  onClick={handleProfileClick}
                  className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer text-left"
                >
                  My Profile
                </li>
                <li
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                    navigate('/lock');
                  }}
                  className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer text-left"
                >
                  Lock
                </li>
                <li
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                    setModalValue({selectedRecord :{}})  
                    dispatch(resetSettings())
                    dispatch(setProviders([]))
                    dispatch(setVisittype([]))
                    dispatch(resetData());
                    localStorage.removeItem('mytab')
                    sessionStorage.removeItem('auth');
                    localStorage.removeItem('auth');
                    setModalValue({ screen :0}) 
                    navigate('/auth1');
                  }}
                  className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer text-left"
                >
                  Logout
                </li>
              </ul>
            </div>
          )}
          </div>
          {ishelpmodal?<RaiseTicketAuth setModal={setIsHelpModal} setOpen={setOpen} setTMessage={setAlertMessage} setSeverity={setSeverity} ismodal={ishelpmodal} data={mydata}/>:<></>}
            <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    </>)
}
export default V2header